export default "__VITE_ASSET__e0e4747a__"